export default __webpack_public_path__ + "static/media/icon-signal-view.4832ed6c.svg";